import * as React from 'react'
import MuiBox from '@mui/material/Box'
import { BoxProps } from '@mui/material'

export function Box(props?: BoxProps) {
  return <MuiBox {...props}>{props.children}</MuiBox>
}
